import { Directive, HostListener, Input } from '@angular/core';
import { Gtm } from '@df/module-gtm/gtm.namespace';
import { GtmService } from '@df/module-gtm/gtm.service';

@Directive()
export abstract class GtmTrackSelectItemAbstract {
    @Input()
    gtmTrackSelectItem: Gtm.ITrackSelectItem;

    @Input()
    gtmTrackSelectItemOff: boolean;

    constructor(protected gtmService: GtmService) {}

    /**
     * Click event listener
     */
    @HostListener('click')
    onClick() {
        if (!this.gtmTrackSelectItemOff) {
            const data = this.gtmTrackSelectItem;
            const items = this.gtmService.getEcommerceItems(data.model);
            const listId = `${data.listId}`.trim();
            const listName = `${data.listName}`.trim();

            const eventData: Gtm.IEventSelectItemData = {
                items: items.map(item => {
                    const itemData = {
                        ...item,
                        index: data.index
                    };

                    if (data.listId) {
                        itemData.item_list_id = listId;
                    }

                    if (data.listName) {
                        itemData.item_list_name = listName;
                    }

                    return itemData;
                })
            };

            if (data.listId) {
                eventData.item_list_id = listId;
            }

            if (data.listName) {
                eventData.item_list_name = listName;
            }

            this.gtmService.trackSelectItem(eventData);
        }
    }
}
